import { api } from '../../../lib/api'

export const DELETE_MESSAGES_REQUEST = 'DELETE_MESSAGES_REQUEST'
export const DELETE_MESSAGES_SUCCESS = 'DELETE_MESSAGES_SUCCESS'
export const DELETE_MESSAGES_FAILED = 'DELETE_MESSAGES_FAILED'

export const deleteMessages = function (messages, onComplete) {
  return function (dispatch) {
    dispatch({
      type: DELETE_MESSAGES_REQUEST
    })
    api.deleteMessages(messages).then(deleteMessagesResponse => {
      dispatch({
        type: DELETE_MESSAGES_SUCCESS,
        payload: deleteMessagesResponse
      })
      
      if (onComplete) onComplete()

    }).catch(error => {
      dispatch({
        type: DELETE_MESSAGES_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/message/delete-messages.js